import type { User } from '@/domain/User';
import { api } from '@/lib/api';
import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mutationKeys } from '../mutationKeys';

export interface UpdateUserRequest {
  id: number;
  role?: string;
  restricted?: boolean;
  can_use_discounts?: boolean;
}

export const deleteUserMutation = (userId: number) => {
  return mutationOptions({
    mutationKey: mutationKeys.users.delete(userId),
    mutationFn: async () => {
      return await api.delete(`users/${userId}`);
    },
    onSuccess: () => {
      toast.success('User deleted successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to delete user');
    },
  });
};

export const updateUserMutation = () => {
  return mutationOptions({
    mutationKey: mutationKeys.users.update(),
    mutationFn: async ({ id, ...data }: UpdateUserRequest) => {
      return await api.put(`users/${id}`, { json: data }).json<User>();
    },
    onSuccess: () => {
      toast.success('User updated successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to update user');
    },
  });
};
